import { Button, Drawer, Form, Input, message, Select, Skeleton, Spin } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { removeDuplicates, StatusCode } from "common/enums";
import AppResult from "components/appResults";
import AppButton from "components/libs/button";
import Pagination from "components/pagination";
import React, { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import IconTopic from "screens/student/searchTeacher/components/iconTopic";
import { handleClearTopicStrings, handleClearTopicStringsLength } from "utils/formats";
import * as TEACHER_SERVICES from "../../../api/services/teacher/teacher.services";
import BackArrow from "../../../assets/images/app/arrow_back_circle.svg";
import Wallet from "../../../assets/images/app/header/wallet.svg";
import { ReactComponent as SearchIcon } from "../../../assets/images/app/search.svg";
import starCoins from "../../../assets/images/app/star-coins.png";
import Student from "../../../assets/images/students/student.svg";
import Teacher from "../../../assets/images/teacher/teacher.svg";
import AppScreen from "../ScreenWithSidebar";
import s from "./style.module.css";

type Props = {
    organimseId: string;
    organimseName: string;
    organismeCredit: any;
    students: any;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
    setOrganismeCredit: React.Dispatch<React.SetStateAction<number>>;
    setStudents: React.Dispatch<React.SetStateAction<Array<any>>>;
}

const { Option } = Select;

const CreditOrganisme: FC<Props> = ({ organimseId, organimseName, organismeCredit, students, setCurrent, setOrganismeCredit, setStudents }) => {

    const [organismeCredits, setOrganismeCredits] = useState<any>(organismeCredit);
    const [selectedStudent, setSelectedStudent] = useState<any>(null);
    const [studentCredit, setStudentCredit] = useState<any>(0);
    const [currentPage, setcurrentPage] = useState<any>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [teachersList, setTeachersList] = useState<any>([]);
    const [attributedTeachersList, setAttributedTeachersList] = useState<any>([]);
    const { user } = useSelector((state) => state.auth);
    const refSubmiteBtn = useRef<any>(null);
    const [searchValue, setSearchValue] = useState("");

    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [isAttributionDrawerVisible, setIsAttributionDrawerVisible] = useState(false);
    const [selectedTeacher, setSelectedTeacher] = useState<any>(null);
    const [price, setPrice] = useState<any>();
    const [cost, setCost] = useState<any>();
    const [creditAllowed, setCreditAllowed] = useState<any>();
    const [teacherLevels, setTeacherLevels] = useState<any>();
    const [selectedLevel, setSelectedLevel] = useState<any>();
    const [tempTopic, setTempTopic] = useState<any>();
    const [isloadingTopic, setIsloadingTopic] = useState<boolean>(false);
    const [showTeacherPrice, setShowTeacherPrice] = useState<boolean>(false);
    const [teacherDataLoaded, setTeacherDataLoaded] = useState<boolean>(false);
    const [selectedTopic, setSelectedTopic] = useState<any>();
    const [teacherPrice, setTeacherPrice] = useState<any>();

    const [totalPages, setTotalPages] = useState<any>(1);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const handleStudentClick = (student: any) => {
        setSelectedStudent(student);
        getTeachers();
    };

    const getTeachers = async () => {
        try {
            setIsLoading(true);
            setTeachersList([]);
            const res = await AUTH_SERVICES.getAllTeachers(currentPage);
            if (res?.data) {
                setTeachersList(res.data.result);
                setTotalPages(res.data?.totalPages);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setIsLoading(false);
        }
    }

    const getTeacher = async () => {
        try {
            setIsLoading(true);
            setTeachersList([]);
            const res = await AUTH_SERVICES.getTeacher(currentPage, searchValue);
            if (res?.data) {
                setTeachersList(res.data.result);
                setTotalPages(res.data?.totalPages);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setIsLoading(false);
        }
    }

    const onSubmit = () => {
        refSubmiteBtn?.current?.click();
    };

    const handleTeacherClick = (data: any) => {
        ///const selectedItem = teachersList.find((item: any) => (item?.teacher?.firstname === teacher?.profObject?.firstname && item?.teacher?.lastname === teacher?.profObject?.lastname));
        setSelectedTeacher(data);
        ///handleStudentAttribution(selectedItem?.teacher?._id);
        handleStudentAttribution(data?.prof?._id);
        setIsAttributionDrawerVisible(false);
        handleTeacherLevels(data);
    };

    // Open drawer with selected teacher details
    const handleButtonClick = (data: any) => {
        setSelectedTeacher(data);
        handleStudentAttribution(data?.prof?._id);
        handleTeacherLevels(data);
    };

    // Close the drawer
    const handleCloseDrawer = () => {
        setIsDrawerVisible(false);
        setSelectedTeacher(null);
        setSelectedLevel(null);
        setSelectedTopic(null);
        setShowTeacherPrice(false);
        setPrice(null);
        setCost(null);
    };

    // Close the drawer
    const handleCloseAttributionDrawer = () => {
        setIsAttributionDrawerVisible(false);
    };

    const handleSearchChange = (e: any) => {
        setSearchValue(e.target.value);
        if (e.target.value.length > 0) {
            const filterTeacher = teachersList.filter((item: any) =>
                item?.teacher.firstname.toLowerCase().includes(e.target.value.toLowerCase()) ||
                item?.teacher.lastname.toLowerCase().includes(e.target.value.toLowerCase()) ||
                item?.teacher.email.toLowerCase().includes(e.target.value.toLowerCase())
            );
            if (filterTeacher.length !== 0) {
                setTeachersList(filterTeacher);
            }
            else {
                console.log("here");
                setcurrentPage(1);
                getTeacher();
            }
        }
        else {
            getTeachers();
        }
    };

    const handleConfirmation = async () => {
        try {
            setLoading(true);

            const response = await TEACHER_SERVICES.setStudentCredit(organimseId, selectedTeacher?.prof?._id, selectedStudent?.key, price, Number(cost), selectedTopic, selectedLevel);
            if (response?.statusCode === StatusCode.CREATED) {
                setOrganismeCredits(response?.data?.data.organismeCredits);
                setOrganismeCredit(response?.data?.data.organismeCredits);
                setStudentCredit(response?.data?.data.studentCredits);
                updateStudentCredit(selectedStudent?.key, response?.data?.data.studentCredits);
                message.success({
                    content: "Crédit attribué avec succès.",
                });
                setSelectedLevel(null);
                setSelectedTopic(null);
                setShowTeacherPrice(false);
                setPrice(null);
                setCost(null);
                if (creditAllowed === 0) {
                    await AUTH_SERVICES.suggestTeacher(organimseId, selectedTeacher?.prof?._id);
                }
            } else {
                message.warning({
                    content: "Erreur d'attribution de crédit à ce prof, merci de réessayer.",
                });
            }
        } catch (error) {
            message.warning({
                content: "Erreur d'attribution de crédit à ce prof, merci de réessayer.",
            });
        }
        finally {
            setLoading(false);
            setIsDrawerVisible(false);
        }
    }

    const updateStudentCredit = (studentKey: any, newCredit: any) => {
        setStudents((prevStudents: any) =>
            prevStudents.map((student: any) =>
                student.key === studentKey
                    ? { ...student, credits: newCredit }
                    : student
            )
        );
    };

    const handleStudentAttributions = async () => {
        try {
            const response = await TEACHER_SERVICES.getStudentsAttibutions("", selectedStudent?.key);
            if (response?.statusCode === StatusCode.OK) {
                console.log(response?.data);
                setAttributedTeachersList(response?.data);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setIsAttributionDrawerVisible(true);
        }
    }

    const handleStudentAttribution = async (teacherId: string) => {
        try {
            const response = await TEACHER_SERVICES.getStudentsAttibutions(teacherId, selectedStudent?.key);
            if (response?.statusCode === StatusCode.OK) {
                const credit = response?.data[0]?.creditsForStudent;
                if (typeof credit === 'number') {
                    setCreditAllowed(credit);
                } else {
                    setCreditAllowed(0);
                }
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setIsDrawerVisible(true);
        }
    }

    const handleTeacherLevels = (data: any) => {
        const levels = data?.prof?.nivMat.map((item: any) => ({
            id: item.niveau._id,
            title: item.niveau.title,
        }));
        setTeacherLevels(levels);
        setTeacherDataLoaded(true);
    }

    // Handle selection of niveau
    const handleNiveauChange = (niveauId: any) => {
        const selectedData = selectedTeacher?.prof?.nivMat.find((item: any) => item.niveau._id === niveauId);
        if (selectedData) {
            const topics = selectedData?.matieres?.map((matiereItem: any) => ({
                id: matiereItem?.matiere?._id,
                title: matiereItem?.matiere?.title,
            }));
            setTempTopic(topics);
        } else {
            setTempTopic([]);
        }
        const levelData = selectedTeacher?.prof?.groupLevels?.find((item: any) => item.levelGroup === selectedData?.niveau?.levelGroup);
        setTeacherPrice(levelData ? levelData.price : 0);
    };

    useEffect(() => {
        setSelectedStudent(students[0]);
    }, [students]);

    useEffect(() => {
        setStudentCredit(selectedStudent?.credits);
    }, [selectedStudent]);

    useEffect(() => {
        getTeachers();
    }, [user]);

    useEffect(() => {
        if (tempTopic) {
            setIsloadingTopic(false);
        }
    }, [tempTopic]);

    useEffect(() => {
        if (creditAllowed !== undefined) {
            setPrice(creditAllowed);
        }
        else if (creditAllowed !== null) {
            setPrice(creditAllowed);
        }
        else {
            setPrice(0);
        }
    }, [creditAllowed]);

    useEffect(() => {
        if (selectedTopic) {
            setShowTeacherPrice(true);
        }
        else {
            setShowTeacherPrice(false);
        }
    }, [selectedTopic]);

    useEffect(() => {
        getTeachers();
    }, [currentPage]);

    return (
        <React.Fragment>
            {/* <Breadcrumbs isBack={false} /> */}
            <AppScreen>
                <div style={{ display: "flex", flexDirection: "column", marginBottom: "0px" }}>
                    <div style={{ display: "flex", flexDirection: "row", background: "#FAFAFA", alignItems: "center", justifyContent: "space-between", height: "120px", paddingLeft: "2%", paddingRight: "2%", borderRadius: "12px" }}>
                        <div style={{ fontSize: "16px", color: "#000" }}><img src={BackArrow} height={20} style={{ marginRight: "20px" }} onClick={() => { setCurrent(1); setStudents([]) }}></img> {organimseName}</div>
                        <div style={{ fontSize: "16px", color: "#000" }}><img src={Wallet} height={40}></img> {Number(organismeCredits).toFixed(2)} CRÉDITS</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "100px", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", background: "#FAFAFA", width: "25%", height: "100%", marginTop: "40px", borderRadius: "12px", alignItems: "center", justifyContent: "flex-start", overflowY: "scroll" }}>
                            {students.map((student: any, key: any) => (
                                <div onClick={() => handleStudentClick(student)} className={selectedStudent?.key === student.key ? s.studentSelectedCard : s.studentCard}>
                                    <div style={{ height: "55px", width: "55px", borderRadius: "50%", background: "#FFF", alignItems: "center", justifyContent: "center", margin: "20px" }}><img src={Student} height={50}></img></div>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center" }}>
                                        <span style={{ color: selectedStudent?.key === student.key ? "#FFF" : "#000" }}>{student.firstname + " " + student.lastname}</span>
                                        <span style={{ backgroundColor: "#D5D5D5", padding: '4px 8px', borderRadius: '12px' }}>
                                            {student.level}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", marginTop: "40px", width: "75%", alignItems: "flex-end" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", borderRadius: "12px", background: "#FAFAFA", width: "98%", height: "70px" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginLeft: "10px" }}>
                                    <div style={{ height: "45px", width: "45px", borderRadius: "50%", background: "#FFF", alignItems: "center", justifyContent: "center", marginRight: "20px" }}><img src={Student} height={40}></img></div>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <span style={{ color: "#000" }}>{selectedStudent?.firstname + " " + selectedStudent?.lastname}</span>
                                        <span style={{ backgroundColor: "#D5D5D5", padding: '4px 8px', borderRadius: '12px', marginLeft: "10px" }}>
                                            {selectedStudent?.level}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginRight: "20px" }}>
                                    <AppButton onClick={handleStudentAttributions} style={{ margin: "0px", padding: "0px" }}>Liste des attributions</AppButton>
                                    <div style={{ fontSize: "14px", color: "#000", marginLeft: "20px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}><img src={Wallet} height={40}></img> <span style={{ marginRight: "5px", marginLeft: "10px" }}>{Number(studentCredit).toFixed(2)}</span> CRÉDITS</div>
                                </div>
                            </div>

                            <div>
                                <Form
                                    layout="inline"
                                    name="searchTeacher"
                                    autoComplete="off"
                                    initialValues={{ search: searchValue }}
                                    onFinish={getTeachers}
                                >
                                    <div className={s.filedSearch}>
                                        <Form.Item name="search">
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                <Input
                                                    type="text"
                                                    value={searchValue}
                                                    onChange={handleSearchChange}
                                                    style={{ border: "0px", marginLeft: "5px" }}
                                                />
                                                <button
                                                    style={{ border: "unset", background: "transparent" }}
                                                >
                                                    <SearchIcon
                                                        style={{
                                                            position: "relative",
                                                            width: "30px",
                                                            top: "3px",
                                                        }}
                                                    />
                                                </button>
                                            </div>
                                        </Form.Item>
                                        <Button
                                            htmlType="submit"
                                            ref={refSubmiteBtn}
                                            style={{ display: "none" }}
                                        >
                                            Go
                                        </Button>
                                    </div>
                                </Form>
                            </div>

                            <div style={{ height: "640px", width: "98%", marginTop: "20px", display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', overflowY: "scroll" }}>
                                {isLoading ? (
                                    <>
                                        <Skeleton active />
                                        <Skeleton active />
                                        <Skeleton active />
                                        <Skeleton active />
                                        <Skeleton active />
                                        <Skeleton active />
                                    </>
                                ) : teachersList.map((item: any, index: any) => {

                                    return (<div className={s.card} key={index}>
                                        <div style={{ height: "75px", width: "75px", background: "#FFF", borderRadius: "50%", alignItems: "center", justifyContent: "center" }}><img src={item?.teacher?.profile || Teacher} height={70} style={{ borderRadius: "50%" }}></img></div>
                                        <div style={{ fontSize: "14px", color: "#000", textTransform: "uppercase", marginTop: "5px" }}>{item?.teacher?.lastname + " " + item?.teacher.firstname}</div>
                                        <div style={{ fontSize: "12px", color: "#000", marginTop: "0px" }}>{item?.teacher?.nivMat[0]?.matieres[0]?.cost}€/heure</div>
                                        {item?.teacher?.matieres.length > 0 && <div className={s.matiers}>
                                            {handleClearTopicStrings(item?.teacher?.matieres)?.slice(0, isMobile ? 2 : 2).map((topic: any, idx: number) => (
                                                topic ? (
                                                    <div className={s.course} key={idx}>
                                                        <IconTopic data={topic} />
                                                        <span>
                                                            {topic.includes("-")
                                                                ? topic.split("-")[0]
                                                                : topic === "Anglais"
                                                                    ? "Anglais"
                                                                    : topic === "Mathématiques"
                                                                        ? "Maths"
                                                                        : topic}
                                                        </span>
                                                    </div>
                                                ) : null
                                            ))} {handleClearTopicStringsLength(item?.teacher?.matieres) > 2 && "..."}
                                        </div>}
                                        <div className={s.levelGroup}>
                                            {item?.teacher?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                                                {removeDuplicates(item?.teacher?.groupLevels)?.slice(0, isMobile ? 2 : 2).map((level: any, index: number) => {
                                                    return (
                                                        level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                                                            <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                                                        </div>
                                                    );
                                                })} {item?.teacher?.groupLevels?.length > 2 && "..."}
                                            </div> : <span>Non renseigné</span>}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", textTransform: "uppercase", fontSize: "10px", marginTop: "10px" }}>
                                            {item?.prof?.langues?.includes("fr") && (
                                                <>
                                                    <span style={{ marginRight: "3px" }}>Français</span>
                                                </>
                                            )}
                                            {item?.prof?.langues?.includes("en") && (
                                                <>
                                                    <span> - Anglais</span>
                                                </>
                                            )}
                                        </div>
                                        <div style={{ paddingLeft: "15%", paddingRight: "15%", marginTop: "20px", position: "absolute", bottom: "20px" }}>
                                            <AppButton onClick={() => handleButtonClick(item)} style={{ margin: "0px", padding: "0px" }}>Gestion des crédits</AppButton>
                                        </div>
                                    </div>);
                                })}
                            </div>

                            {!isLoading && teachersList?.length > 0 && (<div style={{ width: "100%", margin: "20px auto" }}>
                                <Pagination
                                    setCurrentPage={setcurrentPage}
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                />
                            </div>)}
                        </div>
                    </div>

                    <Drawer
                        title={`Attribution de crédits - ${selectedTeacher?.prof?.firstname} ${selectedTeacher?.prof?.lastname}`}
                        placement="right"
                        onClose={handleCloseDrawer}
                        visible={isDrawerVisible}
                        width={"30%"}
                        style={{ zIndex: "2" }}
                    >
                        <div style={{ marginLeft: "20%", marginRight: "20%", }}>
                            <div className={s.card}>
                                <div style={{ height: "75px", width: "75px", background: "#FFF", borderRadius: "50%", alignItems: "center", justifyContent: "center" }}><img src={selectedTeacher?.prof?.profile || Teacher} height={70} style={{ borderRadius: "50%" }}></img></div>
                                <div style={{ fontSize: "14px", color: "#000", textTransform: "uppercase", marginTop: "5px" }}>{selectedTeacher?.prof?.lastname + " " + selectedTeacher?.prof.firstname}</div>
                                <div style={{ fontSize: "12px", color: "#000", marginTop: "0px" }}>{selectedTeacher?.prof?.nivMat[0]?.matieres[0]?.cost}€/heure</div>
                                {selectedTeacher?.prof?.matieres.length > 0 && <div className={s.matiers}>
                                    {handleClearTopicStrings(selectedTeacher?.prof?.matieres)?.slice(0, isMobile ? 2 : 2).map((topic: any, idx: number) => (
                                        topic ? (
                                            <div className={s.course} key={idx}>
                                                <IconTopic data={topic} />
                                                <span>
                                                    {topic.includes("-")
                                                        ? topic.split("-")[0]
                                                        : topic === "Anglais"
                                                            ? "Anglais"
                                                            : topic === "Mathématiques"
                                                                ? "Maths"
                                                                : topic}
                                                </span>
                                            </div>
                                        ) : null
                                    ))} {handleClearTopicStringsLength(selectedTeacher?.prof?.matieres) > 2 && "..."}
                                </div>}
                                <div className={s.levelGroup}>
                                    {selectedTeacher?.prof?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                                        {removeDuplicates(selectedTeacher?.prof?.groupLevels)?.slice(0, isMobile ? 2 : 2).map((level: any, index: number) => {
                                            return (
                                                level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                                                    <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                                                </div>
                                            );
                                        })} {selectedTeacher?.prof?.groupLevels?.length > 2 && "..."}
                                    </div> : <span>Non renseigné</span>}
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", textTransform: "uppercase", fontSize: "10px", marginTop: "10px" }}>
                                    {selectedTeacher?.prof?.langues?.includes("fr") && (
                                        <>
                                            <span style={{ marginRight: "3px" }}>Français</span>
                                        </>
                                    )}
                                    {selectedTeacher?.prof?.langues?.includes("en") && (
                                        <>
                                            <span> - Anglais</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', marginLeft: "20%", marginRight: "20%", display: "flex", flexDirection: "column" }}>

                            {selectedTeacher && teacherDataLoaded && <p><strong>Sélectionner le niveau :</strong></p>}
                            {selectedTeacher && teacherDataLoaded && <div style={{ borderRadius: "8px", border: "1px solid #707070" }}>
                                <Select
                                    placeholder={<span style={{ color: "#000", opacity: "0.8" }}>Niveau</span>}
                                    bordered={false}
                                    onChange={(value) => {
                                        setSelectedLevel(value);
                                        setIsloadingTopic(true);
                                        handleNiveauChange(value);
                                    }}
                                    style={{ width: "100%" }}
                                >
                                    {teacherLevels.map((level: any) => (
                                        <Option key={level?.id} value={level?.id}>
                                            {level?.title}
                                        </Option>
                                    ))}
                                </Select>
                            </div>}

                            {selectedTeacher && teacherDataLoaded && <p style={{ marginTop: "10px" }}><strong>Sélectionner la matière :</strong></p>}
                            {selectedTeacher && teacherDataLoaded && <div style={{ borderRadius: "8px", border: "1px solid #707070" }}>
                                <Select
                                    placeholder={<span style={{ color: "#000", opacity: "0.8" }}>Matière</span>}
                                    allowClear
                                    loading={isloadingTopic}
                                    bordered={false}
                                    onChange={(value) => {
                                        setSelectedTopic(value);
                                    }}
                                    style={{ width: "100%" }}
                                >
                                    {tempTopic?.map((topic: any) => (
                                        <Option key={topic.id} value={topic.id}>
                                            {topic.title}
                                        </Option>
                                    ))}
                                </Select>
                            </div>}

                            {showTeacherPrice && <p style={{ marginTop: "10px" }}><strong>Tarif horaire du prof :</strong></p>}
                            {showTeacherPrice && <Input
                                type="number"
                                value={teacherPrice}
                                className={s.placeholderStyle}
                                style={{ borderRadius: "8px", border: "1px solid #707070" }}
                                readOnly={true}
                            />}

                            <p style={{ marginTop: "10px" }}><strong>Crédit à attribuer :</strong></p>
                            <Input
                                type="number"
                                min={1}
                                value={price}
                                ///onChange={(e) => setPrice(e.target.value)}
                                onChange={(e) => {
                                    let value = e.target.value;

                                    // Remove everything except digits
                                    value = value.replace(/[^0-9]/g, "");

                                    // Prevent 0 or empty
                                    if (value === "" || Number(value) < 1) {
                                        setPrice("");
                                        return;
                                    }

                                    setPrice(value);
                                }}
                                placeholder="Entre le nombre de crédit"
                                className={s.placeholderStyle}
                                style={{ borderRadius: "8px", border: "1px solid #707070" }}
                            />

                            <p style={{ marginTop: "10px" }}><strong>Coût du crédit :</strong></p>
                            <Input
                                type="number"
                                min={1}
                                value={cost}
                                onChange={(e) => setCost(e.target.value)}
                                placeholder="Entre le coût du crédit"
                                className={s.placeholderStyle}
                                style={{ borderRadius: "8px", border: "1px solid #707070" }}
                                suffix="€"
                            />
                            {loading ? <Spin style={{ marginTop: "20px" }} /> : <Button onClick={handleConfirmation} style={{ marginTop: '20px', borderRadius: "20px", background: "#80b1b2", color: "#FFF", width: "50%", margin: "20px auto" }}>
                                Confirmer
                            </Button>}
                        </div>
                    </Drawer>

                    <Drawer
                        title={`Attribution de crédits de ${selectedStudent?.firstname + " " + selectedStudent?.lastname}`}
                        placement="right"
                        onClose={handleCloseAttributionDrawer}
                        visible={isAttributionDrawerVisible}
                        width={"80%"}
                    >
                        {attributedTeachersList.length === 0 ? <AppResult status={"info"} title={"Cet élève n'a aucune attribution."} /> : <div style={{ marginTop: "20px", display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', width: "100%" }}>
                            {attributedTeachersList.map((item: any, index: any) => (
                                <div className={s.cardDrawer} key={index}>
                                    <div style={{ height: "35px", width: "85%", background: "#a9e0e4", marginLeft: "20px", marginBottom: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1em", color: "white", borderRadius: "8px", fontWeight: "400", padding: "4px" }}>
                                        <div style={{ background: "#669e9d", borderRadius: "5px", height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "10px", paddingRight: "10px" }}><div><img src={starCoins} height={15}></img> Crédit </div> <div style={{ fontSize: "1em" }}>{Number(item?.creditsForStudent).toFixed(2)}<span style={{ fontSize: "0.7em", position: "relative", bottom: "5px" }}> CDT</span></div></div>
                                    </div>
                                    <div style={{ height: "75px", width: "75px", background: "#FFF", borderRadius: "50%", alignItems: "center", justifyContent: "center", marginLeft: "20px" }}><img src={item?.profObject?.prof?.profile || Teacher} height={70} style={{ borderRadius: "50%" }}></img></div>
                                    <div style={{ fontSize: "14px", color: "#000", textTransform: "uppercase", marginTop: "5px", marginLeft: "20px" }}>{item?.profObject?.prof?.firstname + " " + item?.profObject?.prof?.lastname}</div>
                                    <div style={{ fontSize: "12px", color: "#000", marginTop: "10px", marginLeft: "20px" }}>Coût du crédit : {item?.creditsCost}</div>
                                    {item?.profObject?.prof?.matieres.length > 0 && <div className={s.matiers} style={{ marginLeft: "20px" }}>
                                        {handleClearTopicStrings(item?.profObject?.prof?.matieres)?.slice(0, isMobile ? 2 : 4).map((topic: any, idx: number) => (
                                            topic ? (
                                                <div className={s.course} key={idx}>
                                                    <IconTopic data={topic} />
                                                    <span>
                                                        {topic.includes("-")
                                                            ? topic.split("-")[0]
                                                            : topic === "Anglais"
                                                                ? "Anglais"
                                                                : topic === "Mathématiques"
                                                                    ? "Maths"
                                                                    : topic}
                                                    </span>
                                                </div>
                                            ) : null
                                        ))} {!isMobile && handleClearTopicStringsLength(item?.profObject?.prof?.matieres) > 4 && "..."}
                                    </div>}

                                    <div className={s.levelGroup} style={{ marginLeft: "20px" }}>
                                        {item?.profObject?.prof?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                                            {removeDuplicates(item?.profObject?.prof?.groupLevels)?.slice(0, isMobile ? 2 : 4).map((level: any, index: number) => {
                                                return (
                                                    <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                        <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                                                    </div>
                                                );
                                            })} {!isMobile && item?.profObject?.prof?.groupLevels?.length > 4 && "..."}
                                        </div> : <span>Non renseigné</span>}
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", textTransform: "uppercase", fontSize: "10px", marginTop: "10px" }}>
                                        {item?.profObject?.language?.includes("fr") && (
                                            <>
                                                <span style={{ marginRight: "3px" }}>Français</span>
                                            </>
                                        )}
                                        {item?.profObject?.language?.includes("en") && (
                                            <>
                                                <span> - Anglais</span>
                                            </>
                                        )}
                                    </div>
                                    {/* <div style={{ padding: "1.5% 5% 1.5% 5%", marginTop: "20px", background: "#FFF", border: "1px solid #80b1b2", borderRadius: "12px", color: "#000" }}>
                                        Crédit attribué : {item?.creditsForStudent}
                                    </div> */}
                                    <div style={{ paddingLeft: "15%", paddingRight: "15%", marginTop: "5px", marginLeft: "20px", position: "absolute", bottom: "20px" }}>
                                        <AppButton onClick={() => handleTeacherClick(item?.profObject)} style={{ margin: "0px", padding: "0px" }}>Gestion des crédits</AppButton>
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </Drawer>
                </div>
            </AppScreen>
        </React.Fragment>
    );
}

export default CreditOrganisme;